<!-- =========================================================================================
	File Name: App.vue
	Description: Main vue file - APP
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div id="app" :class="vueAppClasses">
		<router-view @setAppClasses="setAppClasses" />
	</div>
</template>

<script>
import themeConfig from '@/../themeConfig.js'
import jwt         from "@/http/requests/auth/jwt/index.js"
import VersionCheck from './mixins/VersionCheck.vue'

export default {
  data() {
    return {
      vueAppClasses: [],
    }
  },
  mixins: [VersionCheck],
  watch: {
    '$store.state.theme'(val) {
      this.toggleClassInBody(val)
    },
    '$vs.rtl'(val) {
      document.documentElement.setAttribute("dir", val ? "rtl" : "ltr")
    }
  },
  methods: {
    toggleClassInBody(className) {
      if (className == 'dark') {
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
        document.body.classList.add('theme-dark')
      }
      else if (className == 'semi-dark') {
        if (document.body.className.match('theme-dark')) document.body.classList.remove('theme-dark')
        document.body.classList.add('theme-semi-dark')
      }
      else {
        if (document.body.className.match('theme-dark'))      document.body.classList.remove('theme-dark')
        if (document.body.className.match('theme-semi-dark')) document.body.classList.remove('theme-semi-dark')
      }
    },
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr)
    },
    handleWindowResize() {
      this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

      // Set --vh property
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    handleScroll() {
      this.$store.commit('UPDATE_WINDOW_SCROLL_Y', window.scrollY)
    },
    _calculateScrollbarWidth() {
      document.documentElement.style.setProperty(
        '--scrollbar-width',
        window.innerWidth - document.documentElement.clientWidth + 'px'
      );
    },

    frillScriptSetup() {
      const frillScript = document.createElement('script')
      frillScript.setAttribute('src', require('@/assets/js/frill.js'))
      document.head.appendChild(frillScript)
    }
  },
  mounted() {
    this.toggleClassInBody(themeConfig.theme)
    this.$store.commit('UPDATE_WINDOW_WIDTH', window.innerWidth)

    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    window.addEventListener('message', (event)=>{
      if(event.data.type === 'set-localstorage'){
          Object.keys(event.data.data).forEach((key)=>{
              if(typeof(event.data.data[key]) === 'object'){
                return localStorage.setItem(key, JSON.stringify(event.data.data[key]))
              }
              return localStorage.setItem(key, event.data.data[key])
          })
      }
    }, false)

    this.frillScriptSetup()
  },
  async created() {

    // jwt
    jwt.init()

    let dir = this.$vs.rtl ? "rtl" : "ltr"
    document.documentElement.setAttribute("dir", dir)

    window.addEventListener('resize', this.handleWindowResize)
    window.addEventListener('scroll', this.handleScroll)

    this._calculateScrollbarWidth();

    window.addEventListener('resize', this._calculateScrollbarWidth, false);
    document.addEventListener('DOMContentLoaded', this._calculateScrollbarWidth, false);
    document.addEventListener('mousemove', this._calculateScrollbarWidth, false);
    window.addEventListener('load', this._calculateScrollbarWidth);

    // window.addEventListener('beforeunload', ()=>{
    //   localStorage.clear();
    //   sessionStorage.clear();
    //   window.parent.postMessage({
    //     type: "close-iframe-view",
    //     data: 'logged out'
    //   },"");
    // }, false);

    // Auth0
    // try       { await this.$auth.renewTokens() }
    // catch (e) { console.error(e) }

  },
  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize)
    window.removeEventListener('scroll', this.handleScroll)

    window.removeEventListener('resize', this._calculateScrollbarWidth, false);
    document.removeEventListener('DOMContentLoaded', this._calculateScrollbarWidth, false);
    window.removeEventListener('load', this._calculateScrollbarWidth);
    // window.removeEventListener('beforeunload', ()=>{
    //   localStorage.clear();
    //   sessionStorage.clear();
    //   window.parent.postMessage({
    //     type: "close-iframe-view",
    //     data: 'logged out'
    //   },"");
    // }, false);

  },
}

</script>

<style lang="scss">
  @media screen and (max-width: 500px){
    body #hubspot-messages-iframe-container {
      z-index: 99998 !important;
      bottom: 45px !important;

      & > iframe {
        min-height: 92px;
        height: calc(100% - 45px) !important;
      }
    }
  }
</style>
